import cn from 'classnames'
import { DragNDropFileUploader, IFileSettings } from 'legacy/lut/library/dragNDrop'
import { memo, useCallback } from 'react'

import { IAttachment } from 'clickNgo/models/file'
import { useFormField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'

import { prepareDragNDropAttachments } from './components/helpers/prepareDragNDropAttachments'
import { UploadedFiles } from './components/uploadedFiles/UploadedFiles'
import { IAttachFileProps } from './models'

import styles from './AttachFile.module.scss'

export const AttachFile = memo<IAttachFileProps>(
  ({ attachments = [], formKey, onValidate, isDisabled, isVisible = true, acceptedFormats }) => {
    const field = 'attachments'
    const { handleChange, value, validationMessage } = useFormField<IAttachment[]>({
      defaultValue: attachments,
      field,
      formKey,
      onValidate,
      isVisible,
    })
    const isFileListEmpty = value.length === 0

    const handleDeleteFile = useCallback(
      async (entryId: number) => {
        const newFiles = value.filter((file) => file.entryId !== entryId)
        await handleChange(newFiles)
      },
      [value, handleChange]
    )
    const handleMultiLoadFile = useCallback(
      async (filesInfo: IFileSettings[]) => {
        const newAttachments = prepareDragNDropAttachments(filesInfo)
        await handleChange([...value, ...newAttachments])
      },
      [handleChange, value]
    )

    return (
      <div>
        <div className={styles.validationMessage}>
          <Translation text={validationMessage} span />
        </div>
        <div className={styles.container}>
          <div
            className={cn({
              [styles.isFileListHidden]: isFileListEmpty,
            })}
          >
            <UploadedFiles files={value} onDelete={handleDeleteFile} isDisabled={isDisabled} />
          </div>
          <div
            className={cn({
              [styles.drugNDropContainer]: !isFileListEmpty,
              [styles.drugNDropContainerFull]: isFileListEmpty,
            })}
          >
            <DragNDropFileUploader
              disabled={isDisabled}
              required={false}
              changeFileLoader={handleMultiLoadFile}
              urlInputVisibility={false}
              fileListVisibility={false}
              acceptedFormats={acceptedFormats}
              multifiles
            />
          </div>
        </div>
      </div>
    )
  }
)
